/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  addDecoderSizePrefix,
  addEncoderSizePrefix,
  combineCodec,
  fixDecoderSize,
  fixEncoderSize,
  getAddressDecoder,
  getAddressEncoder,
  getArrayDecoder,
  getArrayEncoder,
  getBytesDecoder,
  getBytesEncoder,
  getProgramDerivedAddress,
  getStructDecoder,
  getStructEncoder,
  getU16Decoder,
  getU16Encoder,
  getU32Decoder,
  getU32Encoder,
  getU64Decoder,
  getU64Encoder,
  getU8Decoder,
  getU8Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  SOLANA_ERROR__PROGRAM_CLIENTS__INSUFFICIENT_ACCOUNT_METAS,
  SolanaError,
  transformEncoder,
  type AccountMeta,
  type AccountSignerMeta,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
  type Instruction,
  type InstructionWithAccounts,
  type InstructionWithData,
  type ReadonlyAccount,
  type ReadonlySignerAccount,
  type ReadonlyUint8Array,
  type TransactionSigner,
  type WritableAccount,
  type WritableSignerAccount,
} from '@solana/kit';
import {
  getAccountMetaFactory,
  getAddressFromResolvedInstructionAccount,
  type ResolvedInstructionAccount,
} from '@solana/program-client-core';
import { INITIALIZER_PROGRAM_ADDRESS } from '../programs';
import {
  getFeeBeneficiaryInputDecoder,
  getFeeBeneficiaryInputEncoder,
  type FeeBeneficiaryInput,
  type FeeBeneficiaryInputArgs,
} from '../types';

export const INITIALIZE_LAUNCH_DISCRIMINATOR = new Uint8Array([
  90, 201, 220, 142, 112, 253, 100, 13,
]);

export function getInitializeLaunchDiscriminatorBytes() {
  return fixEncoderSize(getBytesEncoder(), 8).encode(
    INITIALIZE_LAUNCH_DISCRIMINATOR,
  );
}

export type InitializeLaunchInstruction<
  TProgram extends string = typeof INITIALIZER_PROGRAM_ADDRESS,
  TAccountConfig extends string | AccountMeta<string> = string,
  TAccountLaunch extends string | AccountMeta<string> = string,
  TAccountLaunchAuthority extends string | AccountMeta<string> = string,
  TAccountBaseMint extends string | AccountMeta<string> = string,
  TAccountQuoteMint extends string | AccountMeta<string> = string,
  TAccountBaseVault extends string | AccountMeta<string> = string,
  TAccountQuoteVault extends string | AccountMeta<string> = string,
  TAccountLaunchFeeState extends string | AccountMeta<string> = string,
  TAccountPayer extends string | AccountMeta<string> = string,
  TAccountAuthority extends string | AccountMeta<string> = string,
  TAccountHookProgram extends string | AccountMeta<string> = string,
  TAccountMigratorProgram extends string | AccountMeta<string> = string,
  TAccountBaseTokenProgram extends string | AccountMeta<string> = string,
  TAccountQuoteTokenProgram extends string | AccountMeta<string> = string,
  TAccountSystemProgram extends string | AccountMeta<string> =
    '11111111111111111111111111111111',
  TAccountRent extends string | AccountMeta<string> =
    'SysvarRent111111111111111111111111111111111',
  TAccountMetadataAccount extends string | AccountMeta<string> = string,
  TAccountMetadataProgram extends string | AccountMeta<string> = string,
  TAccountVestingConfig extends string | AccountMeta<string> = string,
  TRemainingAccounts extends readonly AccountMeta<string>[] = [],
> = Instruction<TProgram> &
  InstructionWithData<ReadonlyUint8Array> &
  InstructionWithAccounts<
    [
      TAccountConfig extends string
        ? ReadonlyAccount<TAccountConfig>
        : TAccountConfig,
      TAccountLaunch extends string
        ? WritableAccount<TAccountLaunch>
        : TAccountLaunch,
      TAccountLaunchAuthority extends string
        ? ReadonlyAccount<TAccountLaunchAuthority>
        : TAccountLaunchAuthority,
      TAccountBaseMint extends string
        ? WritableSignerAccount<TAccountBaseMint> &
            AccountSignerMeta<TAccountBaseMint>
        : TAccountBaseMint,
      TAccountQuoteMint extends string
        ? ReadonlyAccount<TAccountQuoteMint>
        : TAccountQuoteMint,
      TAccountBaseVault extends string
        ? WritableSignerAccount<TAccountBaseVault> &
            AccountSignerMeta<TAccountBaseVault>
        : TAccountBaseVault,
      TAccountQuoteVault extends string
        ? WritableSignerAccount<TAccountQuoteVault> &
            AccountSignerMeta<TAccountQuoteVault>
        : TAccountQuoteVault,
      TAccountLaunchFeeState extends string
        ? WritableAccount<TAccountLaunchFeeState>
        : TAccountLaunchFeeState,
      TAccountPayer extends string
        ? WritableSignerAccount<TAccountPayer> &
            AccountSignerMeta<TAccountPayer>
        : TAccountPayer,
      TAccountAuthority extends string
        ? ReadonlySignerAccount<TAccountAuthority> &
            AccountSignerMeta<TAccountAuthority>
        : TAccountAuthority,
      TAccountHookProgram extends string
        ? ReadonlyAccount<TAccountHookProgram>
        : TAccountHookProgram,
      TAccountMigratorProgram extends string
        ? ReadonlyAccount<TAccountMigratorProgram>
        : TAccountMigratorProgram,
      TAccountBaseTokenProgram extends string
        ? ReadonlyAccount<TAccountBaseTokenProgram>
        : TAccountBaseTokenProgram,
      TAccountQuoteTokenProgram extends string
        ? ReadonlyAccount<TAccountQuoteTokenProgram>
        : TAccountQuoteTokenProgram,
      TAccountSystemProgram extends string
        ? ReadonlyAccount<TAccountSystemProgram>
        : TAccountSystemProgram,
      TAccountRent extends string
        ? ReadonlyAccount<TAccountRent>
        : TAccountRent,
      TAccountMetadataAccount extends string
        ? WritableAccount<TAccountMetadataAccount>
        : TAccountMetadataAccount,
      TAccountMetadataProgram extends string
        ? ReadonlyAccount<TAccountMetadataProgram>
        : TAccountMetadataProgram,
      TAccountVestingConfig extends string
        ? ReadonlyAccount<TAccountVestingConfig>
        : TAccountVestingConfig,
      ...TRemainingAccounts,
    ]
  >;

export type InitializeLaunchInstructionData = {
  discriminator: ReadonlyUint8Array;
  namespace: Address;
  launchId: ReadonlyUint8Array;
  baseDecimals: number;
  baseTotalSupply: bigint;
  baseForDistribution: bigint;
  baseForLiquidity: bigint;
  curveVirtualBase: bigint;
  curveVirtualQuote: bigint;
  swapFeeBps: number;
  curveKind: number;
  curveParams: ReadonlyUint8Array;
  allowBuy: number;
  allowSell: number;
  hookFlags: number;
  hookPayload: ReadonlyUint8Array;
  hookCreateRemainingAccountsLen: number;
  migratorInitPayload: ReadonlyUint8Array;
  migratorMigratePayload: ReadonlyUint8Array;
  /**
   * Commitment hash for initialize_launch hook remaining accounts.
   * Computed as hash(u32_len || pubkey_0 || ... || pubkey_n).
   */
  hookCreateRemainingAccountsHash: ReadonlyUint8Array;
  /**
   * Commitment hash for swap/preview hook remaining accounts.
   * Computed as hash(u32_len || pubkey_0 || ... || pubkey_n).
   */
  hookRemainingAccountsHash: ReadonlyUint8Array;
  /**
   * Commitment hash for migrator-init remaining accounts.
   * Computed as hash(u32_len || pubkey_0 || ... || pubkey_n).
   */
  migratorInitRemainingAccountsHash: ReadonlyUint8Array;
  /**
   * Commitment hash for migrator-migrate remaining accounts.
   * Computed as hash(u32_len || pubkey_0 || ... || pubkey_n).
   */
  migratorRemainingAccountsHash: ReadonlyUint8Array;
  /** Token name for on-chain metadata. If empty, metadata creation is skipped. */
  metadataName: string;
  /** Token symbol for on-chain metadata. */
  metadataSymbol: string;
  /** Metadata JSON URI for on-chain metadata. */
  metadataUri: string;
  feeBeneficiaries: Array<FeeBeneficiaryInput>;
};

export type InitializeLaunchInstructionDataArgs = {
  namespace: Address;
  launchId: ReadonlyUint8Array;
  baseDecimals: number;
  baseTotalSupply: number | bigint;
  baseForDistribution: number | bigint;
  baseForLiquidity: number | bigint;
  curveVirtualBase: number | bigint;
  curveVirtualQuote: number | bigint;
  swapFeeBps: number;
  curveKind: number;
  curveParams: ReadonlyUint8Array;
  allowBuy: number;
  allowSell: number;
  hookFlags: number;
  hookPayload: ReadonlyUint8Array;
  hookCreateRemainingAccountsLen: number;
  migratorInitPayload: ReadonlyUint8Array;
  migratorMigratePayload: ReadonlyUint8Array;
  /**
   * Commitment hash for initialize_launch hook remaining accounts.
   * Computed as hash(u32_len || pubkey_0 || ... || pubkey_n).
   */
  hookCreateRemainingAccountsHash: ReadonlyUint8Array;
  /**
   * Commitment hash for swap/preview hook remaining accounts.
   * Computed as hash(u32_len || pubkey_0 || ... || pubkey_n).
   */
  hookRemainingAccountsHash: ReadonlyUint8Array;
  /**
   * Commitment hash for migrator-init remaining accounts.
   * Computed as hash(u32_len || pubkey_0 || ... || pubkey_n).
   */
  migratorInitRemainingAccountsHash: ReadonlyUint8Array;
  /**
   * Commitment hash for migrator-migrate remaining accounts.
   * Computed as hash(u32_len || pubkey_0 || ... || pubkey_n).
   */
  migratorRemainingAccountsHash: ReadonlyUint8Array;
  /** Token name for on-chain metadata. If empty, metadata creation is skipped. */
  metadataName: string;
  /** Token symbol for on-chain metadata. */
  metadataSymbol: string;
  /** Metadata JSON URI for on-chain metadata. */
  metadataUri: string;
  feeBeneficiaries: Array<FeeBeneficiaryInputArgs>;
};

export function getInitializeLaunchInstructionDataEncoder(): Encoder<InitializeLaunchInstructionDataArgs> {
  return transformEncoder(
    getStructEncoder([
      ['discriminator', fixEncoderSize(getBytesEncoder(), 8)],
      ['namespace', getAddressEncoder()],
      ['launchId', fixEncoderSize(getBytesEncoder(), 32)],
      ['baseDecimals', getU8Encoder()],
      ['baseTotalSupply', getU64Encoder()],
      ['baseForDistribution', getU64Encoder()],
      ['baseForLiquidity', getU64Encoder()],
      ['curveVirtualBase', getU64Encoder()],
      ['curveVirtualQuote', getU64Encoder()],
      ['swapFeeBps', getU16Encoder()],
      ['curveKind', getU8Encoder()],
      ['curveParams', addEncoderSizePrefix(getBytesEncoder(), getU32Encoder())],
      ['allowBuy', getU8Encoder()],
      ['allowSell', getU8Encoder()],
      ['hookFlags', getU32Encoder()],
      ['hookPayload', addEncoderSizePrefix(getBytesEncoder(), getU32Encoder())],
      ['hookCreateRemainingAccountsLen', getU32Encoder()],
      [
        'migratorInitPayload',
        addEncoderSizePrefix(getBytesEncoder(), getU32Encoder()),
      ],
      [
        'migratorMigratePayload',
        addEncoderSizePrefix(getBytesEncoder(), getU32Encoder()),
      ],
      [
        'hookCreateRemainingAccountsHash',
        fixEncoderSize(getBytesEncoder(), 32),
      ],
      ['hookRemainingAccountsHash', fixEncoderSize(getBytesEncoder(), 32)],
      [
        'migratorInitRemainingAccountsHash',
        fixEncoderSize(getBytesEncoder(), 32),
      ],
      ['migratorRemainingAccountsHash', fixEncoderSize(getBytesEncoder(), 32)],
      ['metadataName', addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
      [
        'metadataSymbol',
        addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder()),
      ],
      ['metadataUri', addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
      ['feeBeneficiaries', getArrayEncoder(getFeeBeneficiaryInputEncoder())],
    ]),
    (value) => ({ ...value, discriminator: INITIALIZE_LAUNCH_DISCRIMINATOR }),
  );
}

export function getInitializeLaunchInstructionDataDecoder(): Decoder<InitializeLaunchInstructionData> {
  return getStructDecoder([
    ['discriminator', fixDecoderSize(getBytesDecoder(), 8)],
    ['namespace', getAddressDecoder()],
    ['launchId', fixDecoderSize(getBytesDecoder(), 32)],
    ['baseDecimals', getU8Decoder()],
    ['baseTotalSupply', getU64Decoder()],
    ['baseForDistribution', getU64Decoder()],
    ['baseForLiquidity', getU64Decoder()],
    ['curveVirtualBase', getU64Decoder()],
    ['curveVirtualQuote', getU64Decoder()],
    ['swapFeeBps', getU16Decoder()],
    ['curveKind', getU8Decoder()],
    ['curveParams', addDecoderSizePrefix(getBytesDecoder(), getU32Decoder())],
    ['allowBuy', getU8Decoder()],
    ['allowSell', getU8Decoder()],
    ['hookFlags', getU32Decoder()],
    ['hookPayload', addDecoderSizePrefix(getBytesDecoder(), getU32Decoder())],
    ['hookCreateRemainingAccountsLen', getU32Decoder()],
    [
      'migratorInitPayload',
      addDecoderSizePrefix(getBytesDecoder(), getU32Decoder()),
    ],
    [
      'migratorMigratePayload',
      addDecoderSizePrefix(getBytesDecoder(), getU32Decoder()),
    ],
    ['hookCreateRemainingAccountsHash', fixDecoderSize(getBytesDecoder(), 32)],
    ['hookRemainingAccountsHash', fixDecoderSize(getBytesDecoder(), 32)],
    [
      'migratorInitRemainingAccountsHash',
      fixDecoderSize(getBytesDecoder(), 32),
    ],
    ['migratorRemainingAccountsHash', fixDecoderSize(getBytesDecoder(), 32)],
    ['metadataName', addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
    ['metadataSymbol', addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
    ['metadataUri', addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
    ['feeBeneficiaries', getArrayDecoder(getFeeBeneficiaryInputDecoder())],
  ]);
}

export function getInitializeLaunchInstructionDataCodec(): Codec<
  InitializeLaunchInstructionDataArgs,
  InitializeLaunchInstructionData
> {
  return combineCodec(
    getInitializeLaunchInstructionDataEncoder(),
    getInitializeLaunchInstructionDataDecoder(),
  );
}

export type InitializeLaunchAsyncInput<
  TAccountConfig extends string = string,
  TAccountLaunch extends string = string,
  TAccountLaunchAuthority extends string = string,
  TAccountBaseMint extends string = string,
  TAccountQuoteMint extends string = string,
  TAccountBaseVault extends string = string,
  TAccountQuoteVault extends string = string,
  TAccountLaunchFeeState extends string = string,
  TAccountPayer extends string = string,
  TAccountAuthority extends string = string,
  TAccountHookProgram extends string = string,
  TAccountMigratorProgram extends string = string,
  TAccountBaseTokenProgram extends string = string,
  TAccountQuoteTokenProgram extends string = string,
  TAccountSystemProgram extends string = string,
  TAccountRent extends string = string,
  TAccountMetadataAccount extends string = string,
  TAccountMetadataProgram extends string = string,
  TAccountVestingConfig extends string = string,
> = {
  config?: Address<TAccountConfig>;
  launch: Address<TAccountLaunch>;
  /** System-owned PDA authority for launch vaults. */
  launchAuthority?: Address<TAccountLaunchAuthority>;
  baseMint: TransactionSigner<TAccountBaseMint>;
  quoteMint: Address<TAccountQuoteMint>;
  baseVault: TransactionSigner<TAccountBaseVault>;
  quoteVault: TransactionSigner<TAccountQuoteVault>;
  launchFeeState?: Address<TAccountLaunchFeeState>;
  payer: TransactionSigner<TAccountPayer>;
  /** Optional authority (creator/admin). If not provided, launch is permissionless. */
  authority?: TransactionSigner<TAccountAuthority>;
  /** Optional hook program for launch hooks. */
  hookProgram?: Address<TAccountHookProgram>;
  /** Optional migrator program. */
  migratorProgram?: Address<TAccountMigratorProgram>;
  baseTokenProgram: Address<TAccountBaseTokenProgram>;
  quoteTokenProgram: Address<TAccountQuoteTokenProgram>;
  systemProgram?: Address<TAccountSystemProgram>;
  rent?: Address<TAccountRent>;
  /** Metadata account (PDA derived from base_mint via Metaplex Token Metadata). */
  metadataAccount?: Address<TAccountMetadataAccount>;
  /** Metaplex Token Metadata program. */
  metadataProgram?: Address<TAccountMetadataProgram>;
  /** Optional immutable vesting configuration for the reserved base allocation. */
  vestingConfig?: Address<TAccountVestingConfig>;
  namespace: InitializeLaunchInstructionDataArgs['namespace'];
  launchId: InitializeLaunchInstructionDataArgs['launchId'];
  baseDecimals: InitializeLaunchInstructionDataArgs['baseDecimals'];
  baseTotalSupply: InitializeLaunchInstructionDataArgs['baseTotalSupply'];
  baseForDistribution: InitializeLaunchInstructionDataArgs['baseForDistribution'];
  baseForLiquidity: InitializeLaunchInstructionDataArgs['baseForLiquidity'];
  curveVirtualBase: InitializeLaunchInstructionDataArgs['curveVirtualBase'];
  curveVirtualQuote: InitializeLaunchInstructionDataArgs['curveVirtualQuote'];
  swapFeeBps: InitializeLaunchInstructionDataArgs['swapFeeBps'];
  curveKind: InitializeLaunchInstructionDataArgs['curveKind'];
  curveParams: InitializeLaunchInstructionDataArgs['curveParams'];
  allowBuy: InitializeLaunchInstructionDataArgs['allowBuy'];
  allowSell: InitializeLaunchInstructionDataArgs['allowSell'];
  hookFlags: InitializeLaunchInstructionDataArgs['hookFlags'];
  hookPayload: InitializeLaunchInstructionDataArgs['hookPayload'];
  hookCreateRemainingAccountsLen: InitializeLaunchInstructionDataArgs['hookCreateRemainingAccountsLen'];
  migratorInitPayload: InitializeLaunchInstructionDataArgs['migratorInitPayload'];
  migratorMigratePayload: InitializeLaunchInstructionDataArgs['migratorMigratePayload'];
  hookCreateRemainingAccountsHash: InitializeLaunchInstructionDataArgs['hookCreateRemainingAccountsHash'];
  hookRemainingAccountsHash: InitializeLaunchInstructionDataArgs['hookRemainingAccountsHash'];
  migratorInitRemainingAccountsHash: InitializeLaunchInstructionDataArgs['migratorInitRemainingAccountsHash'];
  migratorRemainingAccountsHash: InitializeLaunchInstructionDataArgs['migratorRemainingAccountsHash'];
  metadataName: InitializeLaunchInstructionDataArgs['metadataName'];
  metadataSymbol: InitializeLaunchInstructionDataArgs['metadataSymbol'];
  metadataUri: InitializeLaunchInstructionDataArgs['metadataUri'];
  feeBeneficiaries: InitializeLaunchInstructionDataArgs['feeBeneficiaries'];
};

export async function getInitializeLaunchInstructionAsync<
  TAccountConfig extends string,
  TAccountLaunch extends string,
  TAccountLaunchAuthority extends string,
  TAccountBaseMint extends string,
  TAccountQuoteMint extends string,
  TAccountBaseVault extends string,
  TAccountQuoteVault extends string,
  TAccountLaunchFeeState extends string,
  TAccountPayer extends string,
  TAccountAuthority extends string,
  TAccountHookProgram extends string,
  TAccountMigratorProgram extends string,
  TAccountBaseTokenProgram extends string,
  TAccountQuoteTokenProgram extends string,
  TAccountSystemProgram extends string,
  TAccountRent extends string,
  TAccountMetadataAccount extends string,
  TAccountMetadataProgram extends string,
  TAccountVestingConfig extends string,
  TProgramAddress extends Address = typeof INITIALIZER_PROGRAM_ADDRESS,
>(
  input: InitializeLaunchAsyncInput<
    TAccountConfig,
    TAccountLaunch,
    TAccountLaunchAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountBaseVault,
    TAccountQuoteVault,
    TAccountLaunchFeeState,
    TAccountPayer,
    TAccountAuthority,
    TAccountHookProgram,
    TAccountMigratorProgram,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram,
    TAccountSystemProgram,
    TAccountRent,
    TAccountMetadataAccount,
    TAccountMetadataProgram,
    TAccountVestingConfig
  >,
  config?: { programAddress?: TProgramAddress },
): Promise<
  InitializeLaunchInstruction<
    TProgramAddress,
    TAccountConfig,
    TAccountLaunch,
    TAccountLaunchAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountBaseVault,
    TAccountQuoteVault,
    TAccountLaunchFeeState,
    TAccountPayer,
    TAccountAuthority,
    TAccountHookProgram,
    TAccountMigratorProgram,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram,
    TAccountSystemProgram,
    TAccountRent,
    TAccountMetadataAccount,
    TAccountMetadataProgram,
    TAccountVestingConfig
  >
> {
  // Program address.
  const programAddress = config?.programAddress ?? INITIALIZER_PROGRAM_ADDRESS;

  // Original accounts.
  const originalAccounts = {
    config: { value: input.config ?? null, isWritable: false },
    launch: { value: input.launch ?? null, isWritable: true },
    launchAuthority: {
      value: input.launchAuthority ?? null,
      isWritable: false,
    },
    baseMint: { value: input.baseMint ?? null, isWritable: true },
    quoteMint: { value: input.quoteMint ?? null, isWritable: false },
    baseVault: { value: input.baseVault ?? null, isWritable: true },
    quoteVault: { value: input.quoteVault ?? null, isWritable: true },
    launchFeeState: { value: input.launchFeeState ?? null, isWritable: true },
    payer: { value: input.payer ?? null, isWritable: true },
    authority: { value: input.authority ?? null, isWritable: false },
    hookProgram: { value: input.hookProgram ?? null, isWritable: false },
    migratorProgram: {
      value: input.migratorProgram ?? null,
      isWritable: false,
    },
    baseTokenProgram: {
      value: input.baseTokenProgram ?? null,
      isWritable: false,
    },
    quoteTokenProgram: {
      value: input.quoteTokenProgram ?? null,
      isWritable: false,
    },
    systemProgram: { value: input.systemProgram ?? null, isWritable: false },
    rent: { value: input.rent ?? null, isWritable: false },
    metadataAccount: { value: input.metadataAccount ?? null, isWritable: true },
    metadataProgram: {
      value: input.metadataProgram ?? null,
      isWritable: false,
    },
    vestingConfig: { value: input.vestingConfig ?? null, isWritable: false },
  };
  const accounts = originalAccounts as Record<
    keyof typeof originalAccounts,
    ResolvedInstructionAccount
  >;

  // Original args.
  const args = { ...input };

  // Resolve default values.
  if (!accounts.config.value) {
    accounts.config.value = await getProgramDerivedAddress({
      programAddress,
      seeds: [
        getBytesEncoder().encode(new Uint8Array([99, 111, 110, 102, 105, 103])),
      ],
    });
  }
  if (!accounts.launchAuthority.value) {
    accounts.launchAuthority.value = await getProgramDerivedAddress({
      programAddress,
      seeds: [
        getBytesEncoder().encode(
          new Uint8Array([
            108, 97, 117, 110, 99, 104, 95, 97, 117, 116, 104, 111, 114, 105,
            116, 121,
          ]),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'launch',
            accounts.launch.value,
          ),
        ),
      ],
    });
  }
  if (!accounts.launchFeeState.value) {
    accounts.launchFeeState.value = await getProgramDerivedAddress({
      programAddress,
      seeds: [
        getBytesEncoder().encode(
          new Uint8Array([
            108, 97, 117, 110, 99, 104, 95, 102, 101, 101, 95, 115, 116, 97,
            116, 101,
          ]),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'launch',
            accounts.launch.value,
          ),
        ),
      ],
    });
  }
  if (!accounts.systemProgram.value) {
    accounts.systemProgram.value =
      '11111111111111111111111111111111' as Address<'11111111111111111111111111111111'>;
  }
  if (!accounts.rent.value) {
    accounts.rent.value =
      'SysvarRent111111111111111111111111111111111' as Address<'SysvarRent111111111111111111111111111111111'>;
  }

  const getAccountMeta = getAccountMetaFactory(programAddress, 'programId');
  return Object.freeze({
    accounts: [
      getAccountMeta('config', accounts.config),
      getAccountMeta('launch', accounts.launch),
      getAccountMeta('launchAuthority', accounts.launchAuthority),
      getAccountMeta('baseMint', accounts.baseMint),
      getAccountMeta('quoteMint', accounts.quoteMint),
      getAccountMeta('baseVault', accounts.baseVault),
      getAccountMeta('quoteVault', accounts.quoteVault),
      getAccountMeta('launchFeeState', accounts.launchFeeState),
      getAccountMeta('payer', accounts.payer),
      getAccountMeta('authority', accounts.authority),
      getAccountMeta('hookProgram', accounts.hookProgram),
      getAccountMeta('migratorProgram', accounts.migratorProgram),
      getAccountMeta('baseTokenProgram', accounts.baseTokenProgram),
      getAccountMeta('quoteTokenProgram', accounts.quoteTokenProgram),
      getAccountMeta('systemProgram', accounts.systemProgram),
      getAccountMeta('rent', accounts.rent),
      getAccountMeta('metadataAccount', accounts.metadataAccount),
      getAccountMeta('metadataProgram', accounts.metadataProgram),
      getAccountMeta('vestingConfig', accounts.vestingConfig),
    ],
    data: getInitializeLaunchInstructionDataEncoder().encode(
      args as InitializeLaunchInstructionDataArgs,
    ),
    programAddress,
  } as InitializeLaunchInstruction<
    TProgramAddress,
    TAccountConfig,
    TAccountLaunch,
    TAccountLaunchAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountBaseVault,
    TAccountQuoteVault,
    TAccountLaunchFeeState,
    TAccountPayer,
    TAccountAuthority,
    TAccountHookProgram,
    TAccountMigratorProgram,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram,
    TAccountSystemProgram,
    TAccountRent,
    TAccountMetadataAccount,
    TAccountMetadataProgram,
    TAccountVestingConfig
  >);
}

export type InitializeLaunchInput<
  TAccountConfig extends string = string,
  TAccountLaunch extends string = string,
  TAccountLaunchAuthority extends string = string,
  TAccountBaseMint extends string = string,
  TAccountQuoteMint extends string = string,
  TAccountBaseVault extends string = string,
  TAccountQuoteVault extends string = string,
  TAccountLaunchFeeState extends string = string,
  TAccountPayer extends string = string,
  TAccountAuthority extends string = string,
  TAccountHookProgram extends string = string,
  TAccountMigratorProgram extends string = string,
  TAccountBaseTokenProgram extends string = string,
  TAccountQuoteTokenProgram extends string = string,
  TAccountSystemProgram extends string = string,
  TAccountRent extends string = string,
  TAccountMetadataAccount extends string = string,
  TAccountMetadataProgram extends string = string,
  TAccountVestingConfig extends string = string,
> = {
  config: Address<TAccountConfig>;
  launch: Address<TAccountLaunch>;
  /** System-owned PDA authority for launch vaults. */
  launchAuthority: Address<TAccountLaunchAuthority>;
  baseMint: TransactionSigner<TAccountBaseMint>;
  quoteMint: Address<TAccountQuoteMint>;
  baseVault: TransactionSigner<TAccountBaseVault>;
  quoteVault: TransactionSigner<TAccountQuoteVault>;
  launchFeeState: Address<TAccountLaunchFeeState>;
  payer: TransactionSigner<TAccountPayer>;
  /** Optional authority (creator/admin). If not provided, launch is permissionless. */
  authority?: TransactionSigner<TAccountAuthority>;
  /** Optional hook program for launch hooks. */
  hookProgram?: Address<TAccountHookProgram>;
  /** Optional migrator program. */
  migratorProgram?: Address<TAccountMigratorProgram>;
  baseTokenProgram: Address<TAccountBaseTokenProgram>;
  quoteTokenProgram: Address<TAccountQuoteTokenProgram>;
  systemProgram?: Address<TAccountSystemProgram>;
  rent?: Address<TAccountRent>;
  /** Metadata account (PDA derived from base_mint via Metaplex Token Metadata). */
  metadataAccount?: Address<TAccountMetadataAccount>;
  /** Metaplex Token Metadata program. */
  metadataProgram?: Address<TAccountMetadataProgram>;
  /** Optional immutable vesting configuration for the reserved base allocation. */
  vestingConfig?: Address<TAccountVestingConfig>;
  namespace: InitializeLaunchInstructionDataArgs['namespace'];
  launchId: InitializeLaunchInstructionDataArgs['launchId'];
  baseDecimals: InitializeLaunchInstructionDataArgs['baseDecimals'];
  baseTotalSupply: InitializeLaunchInstructionDataArgs['baseTotalSupply'];
  baseForDistribution: InitializeLaunchInstructionDataArgs['baseForDistribution'];
  baseForLiquidity: InitializeLaunchInstructionDataArgs['baseForLiquidity'];
  curveVirtualBase: InitializeLaunchInstructionDataArgs['curveVirtualBase'];
  curveVirtualQuote: InitializeLaunchInstructionDataArgs['curveVirtualQuote'];
  swapFeeBps: InitializeLaunchInstructionDataArgs['swapFeeBps'];
  curveKind: InitializeLaunchInstructionDataArgs['curveKind'];
  curveParams: InitializeLaunchInstructionDataArgs['curveParams'];
  allowBuy: InitializeLaunchInstructionDataArgs['allowBuy'];
  allowSell: InitializeLaunchInstructionDataArgs['allowSell'];
  hookFlags: InitializeLaunchInstructionDataArgs['hookFlags'];
  hookPayload: InitializeLaunchInstructionDataArgs['hookPayload'];
  hookCreateRemainingAccountsLen: InitializeLaunchInstructionDataArgs['hookCreateRemainingAccountsLen'];
  migratorInitPayload: InitializeLaunchInstructionDataArgs['migratorInitPayload'];
  migratorMigratePayload: InitializeLaunchInstructionDataArgs['migratorMigratePayload'];
  hookCreateRemainingAccountsHash: InitializeLaunchInstructionDataArgs['hookCreateRemainingAccountsHash'];
  hookRemainingAccountsHash: InitializeLaunchInstructionDataArgs['hookRemainingAccountsHash'];
  migratorInitRemainingAccountsHash: InitializeLaunchInstructionDataArgs['migratorInitRemainingAccountsHash'];
  migratorRemainingAccountsHash: InitializeLaunchInstructionDataArgs['migratorRemainingAccountsHash'];
  metadataName: InitializeLaunchInstructionDataArgs['metadataName'];
  metadataSymbol: InitializeLaunchInstructionDataArgs['metadataSymbol'];
  metadataUri: InitializeLaunchInstructionDataArgs['metadataUri'];
  feeBeneficiaries: InitializeLaunchInstructionDataArgs['feeBeneficiaries'];
};

export function getInitializeLaunchInstruction<
  TAccountConfig extends string,
  TAccountLaunch extends string,
  TAccountLaunchAuthority extends string,
  TAccountBaseMint extends string,
  TAccountQuoteMint extends string,
  TAccountBaseVault extends string,
  TAccountQuoteVault extends string,
  TAccountLaunchFeeState extends string,
  TAccountPayer extends string,
  TAccountAuthority extends string,
  TAccountHookProgram extends string,
  TAccountMigratorProgram extends string,
  TAccountBaseTokenProgram extends string,
  TAccountQuoteTokenProgram extends string,
  TAccountSystemProgram extends string,
  TAccountRent extends string,
  TAccountMetadataAccount extends string,
  TAccountMetadataProgram extends string,
  TAccountVestingConfig extends string,
  TProgramAddress extends Address = typeof INITIALIZER_PROGRAM_ADDRESS,
>(
  input: InitializeLaunchInput<
    TAccountConfig,
    TAccountLaunch,
    TAccountLaunchAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountBaseVault,
    TAccountQuoteVault,
    TAccountLaunchFeeState,
    TAccountPayer,
    TAccountAuthority,
    TAccountHookProgram,
    TAccountMigratorProgram,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram,
    TAccountSystemProgram,
    TAccountRent,
    TAccountMetadataAccount,
    TAccountMetadataProgram,
    TAccountVestingConfig
  >,
  config?: { programAddress?: TProgramAddress },
): InitializeLaunchInstruction<
  TProgramAddress,
  TAccountConfig,
  TAccountLaunch,
  TAccountLaunchAuthority,
  TAccountBaseMint,
  TAccountQuoteMint,
  TAccountBaseVault,
  TAccountQuoteVault,
  TAccountLaunchFeeState,
  TAccountPayer,
  TAccountAuthority,
  TAccountHookProgram,
  TAccountMigratorProgram,
  TAccountBaseTokenProgram,
  TAccountQuoteTokenProgram,
  TAccountSystemProgram,
  TAccountRent,
  TAccountMetadataAccount,
  TAccountMetadataProgram,
  TAccountVestingConfig
> {
  // Program address.
  const programAddress = config?.programAddress ?? INITIALIZER_PROGRAM_ADDRESS;

  // Original accounts.
  const originalAccounts = {
    config: { value: input.config ?? null, isWritable: false },
    launch: { value: input.launch ?? null, isWritable: true },
    launchAuthority: {
      value: input.launchAuthority ?? null,
      isWritable: false,
    },
    baseMint: { value: input.baseMint ?? null, isWritable: true },
    quoteMint: { value: input.quoteMint ?? null, isWritable: false },
    baseVault: { value: input.baseVault ?? null, isWritable: true },
    quoteVault: { value: input.quoteVault ?? null, isWritable: true },
    launchFeeState: { value: input.launchFeeState ?? null, isWritable: true },
    payer: { value: input.payer ?? null, isWritable: true },
    authority: { value: input.authority ?? null, isWritable: false },
    hookProgram: { value: input.hookProgram ?? null, isWritable: false },
    migratorProgram: {
      value: input.migratorProgram ?? null,
      isWritable: false,
    },
    baseTokenProgram: {
      value: input.baseTokenProgram ?? null,
      isWritable: false,
    },
    quoteTokenProgram: {
      value: input.quoteTokenProgram ?? null,
      isWritable: false,
    },
    systemProgram: { value: input.systemProgram ?? null, isWritable: false },
    rent: { value: input.rent ?? null, isWritable: false },
    metadataAccount: { value: input.metadataAccount ?? null, isWritable: true },
    metadataProgram: {
      value: input.metadataProgram ?? null,
      isWritable: false,
    },
    vestingConfig: { value: input.vestingConfig ?? null, isWritable: false },
  };
  const accounts = originalAccounts as Record<
    keyof typeof originalAccounts,
    ResolvedInstructionAccount
  >;

  // Original args.
  const args = { ...input };

  // Resolve default values.
  if (!accounts.systemProgram.value) {
    accounts.systemProgram.value =
      '11111111111111111111111111111111' as Address<'11111111111111111111111111111111'>;
  }
  if (!accounts.rent.value) {
    accounts.rent.value =
      'SysvarRent111111111111111111111111111111111' as Address<'SysvarRent111111111111111111111111111111111'>;
  }

  const getAccountMeta = getAccountMetaFactory(programAddress, 'programId');
  return Object.freeze({
    accounts: [
      getAccountMeta('config', accounts.config),
      getAccountMeta('launch', accounts.launch),
      getAccountMeta('launchAuthority', accounts.launchAuthority),
      getAccountMeta('baseMint', accounts.baseMint),
      getAccountMeta('quoteMint', accounts.quoteMint),
      getAccountMeta('baseVault', accounts.baseVault),
      getAccountMeta('quoteVault', accounts.quoteVault),
      getAccountMeta('launchFeeState', accounts.launchFeeState),
      getAccountMeta('payer', accounts.payer),
      getAccountMeta('authority', accounts.authority),
      getAccountMeta('hookProgram', accounts.hookProgram),
      getAccountMeta('migratorProgram', accounts.migratorProgram),
      getAccountMeta('baseTokenProgram', accounts.baseTokenProgram),
      getAccountMeta('quoteTokenProgram', accounts.quoteTokenProgram),
      getAccountMeta('systemProgram', accounts.systemProgram),
      getAccountMeta('rent', accounts.rent),
      getAccountMeta('metadataAccount', accounts.metadataAccount),
      getAccountMeta('metadataProgram', accounts.metadataProgram),
      getAccountMeta('vestingConfig', accounts.vestingConfig),
    ],
    data: getInitializeLaunchInstructionDataEncoder().encode(
      args as InitializeLaunchInstructionDataArgs,
    ),
    programAddress,
  } as InitializeLaunchInstruction<
    TProgramAddress,
    TAccountConfig,
    TAccountLaunch,
    TAccountLaunchAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountBaseVault,
    TAccountQuoteVault,
    TAccountLaunchFeeState,
    TAccountPayer,
    TAccountAuthority,
    TAccountHookProgram,
    TAccountMigratorProgram,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram,
    TAccountSystemProgram,
    TAccountRent,
    TAccountMetadataAccount,
    TAccountMetadataProgram,
    TAccountVestingConfig
  >);
}

export type ParsedInitializeLaunchInstruction<
  TProgram extends string = typeof INITIALIZER_PROGRAM_ADDRESS,
  TAccountMetas extends readonly AccountMeta[] = readonly AccountMeta[],
> = {
  programAddress: Address<TProgram>;
  accounts: {
    config: TAccountMetas[0];
    launch: TAccountMetas[1];
    /** System-owned PDA authority for launch vaults. */
    launchAuthority: TAccountMetas[2];
    baseMint: TAccountMetas[3];
    quoteMint: TAccountMetas[4];
    baseVault: TAccountMetas[5];
    quoteVault: TAccountMetas[6];
    launchFeeState: TAccountMetas[7];
    payer: TAccountMetas[8];
    /** Optional authority (creator/admin). If not provided, launch is permissionless. */
    authority?: TAccountMetas[9] | undefined;
    /** Optional hook program for launch hooks. */
    hookProgram?: TAccountMetas[10] | undefined;
    /** Optional migrator program. */
    migratorProgram?: TAccountMetas[11] | undefined;
    baseTokenProgram: TAccountMetas[12];
    quoteTokenProgram: TAccountMetas[13];
    systemProgram: TAccountMetas[14];
    rent: TAccountMetas[15];
    /** Metadata account (PDA derived from base_mint via Metaplex Token Metadata). */
    metadataAccount?: TAccountMetas[16] | undefined;
    /** Metaplex Token Metadata program. */
    metadataProgram?: TAccountMetas[17] | undefined;
    /** Optional immutable vesting configuration for the reserved base allocation. */
    vestingConfig?: TAccountMetas[18] | undefined;
  };
  data: InitializeLaunchInstructionData;
};

export function parseInitializeLaunchInstruction<
  TProgram extends string,
  TAccountMetas extends readonly AccountMeta[],
>(
  instruction: Instruction<TProgram> &
    InstructionWithAccounts<TAccountMetas> &
    InstructionWithData<ReadonlyUint8Array>,
): ParsedInitializeLaunchInstruction<TProgram, TAccountMetas> {
  if (instruction.accounts.length < 19) {
    throw new SolanaError(
      SOLANA_ERROR__PROGRAM_CLIENTS__INSUFFICIENT_ACCOUNT_METAS,
      {
        actualAccountMetas: instruction.accounts.length,
        expectedAccountMetas: 19,
      },
    );
  }
  let accountIndex = 0;
  const getNextAccount = () => {
    const accountMeta = (instruction.accounts as TAccountMetas)[accountIndex]!;
    accountIndex += 1;
    return accountMeta;
  };
  const getNextOptionalAccount = () => {
    const accountMeta = getNextAccount();
    return accountMeta.address === INITIALIZER_PROGRAM_ADDRESS
      ? undefined
      : accountMeta;
  };
  return {
    programAddress: instruction.programAddress,
    accounts: {
      config: getNextAccount(),
      launch: getNextAccount(),
      launchAuthority: getNextAccount(),
      baseMint: getNextAccount(),
      quoteMint: getNextAccount(),
      baseVault: getNextAccount(),
      quoteVault: getNextAccount(),
      launchFeeState: getNextAccount(),
      payer: getNextAccount(),
      authority: getNextOptionalAccount(),
      hookProgram: getNextOptionalAccount(),
      migratorProgram: getNextOptionalAccount(),
      baseTokenProgram: getNextAccount(),
      quoteTokenProgram: getNextAccount(),
      systemProgram: getNextAccount(),
      rent: getNextAccount(),
      metadataAccount: getNextOptionalAccount(),
      metadataProgram: getNextOptionalAccount(),
      vestingConfig: getNextOptionalAccount(),
    },
    data: getInitializeLaunchInstructionDataDecoder().decode(instruction.data),
  };
}
